import React, { useEffect, useRef } from 'react';
import styles from './YoutubeVideoWrapper.module.css';

type YoutubeVideoWrapperProps = {
  iframe: string;
};

export default function YoutubeVideoWrapper({ iframe }: YoutubeVideoWrapperProps) {
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const parser = new DOMParser();
    const new_node = parser.parseFromString(iframe, 'text/html').body.firstChild;
    const el = divRef.current;

    if (el && new_node) {
      el.appendChild(new_node);
    }
  }, [divRef.current]);

  return <div className={styles.videoYoutubeArticle} ref={divRef} />;
}
